export const BROWSER_MODE = typeof window !== 'undefined' && typeof document !== 'undefined';
